import { Events } from '@ezchops/helpers';
import { useEffect, useState } from 'react';
export class Clock extends Events.EventEmitter {
    seek = (time) => this._seek(time).then((now) => this.emit('seeked', now));
    pause = () => this._pause().then((now) => this.emit('paused', now));
    end = () => this._end().then((now) => this.emit('ended', now));
    resume = () => this._resume().then((now) => this.emit('resumed', now));
    reset = () => this._reset().then((now) => this.emit('reset', now));
    async restart() {
        await this.reset();
        await this.resume();
    }
    async _reset() {
        if (this.isRunning) {
            await this._pause();
        }
        await this._seek(0);
        return 0;
    }
}
export function useClockRunning(clock) {
    const [trackState, setTrackState] = useState(false);
    useEffect(() => {
        if (clock) {
            const updateState = () => {
                setTrackState(clock.isRunning);
            };
            updateState();
            clock.addEventListener('resumed', updateState);
            clock.addEventListener('paused', updateState);
            clock.addEventListener('ended', updateState);
            return () => {
                clock.removeEventListener('resumed', updateState);
                clock.removeEventListener('paused', updateState);
                clock.removeEventListener('ended', updateState);
            };
        }
    }, [clock]);
    return trackState;
}
//# sourceMappingURL=Clock.js.map